import { cohortCurriculumProgram, type CurriculumEntry, type CurriculumTrack } from '../data/cohortCurriculum'

interface PackageLike {
  level?: number | string | null
  title?: string | null
  name?: string | null
}

export function isBasicPackage(pkg?: PackageLike | null): boolean {
  const label = `${pkg?.title || ''} ${pkg?.name || ''}`.toLowerCase()
  return label.includes('basic')
}

export function resolveCurriculumTrack(level: number, pkg?: PackageLike | null): CurriculumTrack {
  if (level <= 2) {
    return isBasicPackage(pkg) ? 'Basic' : 'Advanced'
  }
  return 'Standard'
}

export function getCurriculumForPackage(pkg?: PackageLike | null): CurriculumEntry | null {
  const level = Number(pkg?.level)
  if (!level || level < 1 || level > 12) return null

  const track = resolveCurriculumTrack(level, pkg)
  const levelLabel = `Level ${level}`

  return (
    cohortCurriculumProgram.levels.find(
      (entry) => entry.level === levelLabel && entry.track === track,
    ) || null
  )
}
